module.exports = __webpack_public_path__ + "img/IMG_1401_FoamcoreMatted.33562c34.jpg";